const SoldDataTableRowsProps = {
  props: {
    tableRows: {
      default: () => ([]),
      type: Array,
    },
  },
};

export default SoldDataTableRowsProps;
